module.exports = __webpack_public_path__ + "img/rare.f72e2a77.svg";